var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_3756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_3756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13.25V16.5C11.75 16.7125 11.8219 16.8906 11.9658 17.0343C12.1096 17.1781 12.2878 17.25 12.5003 17.25C12.7129 17.25 12.891 17.1781 13.0345 17.0343C13.1782 16.8906 13.25 16.7125 13.25 16.5V13.25H16.5C16.7125 13.25 16.8906 13.1781 17.0343 13.0343C17.1781 12.8904 17.25 12.7122 17.25 12.4998C17.25 12.2871 17.1781 12.109 17.0343 11.9655C16.8906 11.8218 16.7125 11.75 16.5 11.75H13.25V8.5C13.25 8.2875 13.1781 8.10942 13.0343 7.96575C12.8904 7.82192 12.7122 7.75 12.4998 7.75C12.2871 7.75 12.109 7.82192 11.9655 7.96575C11.8218 8.10942 11.75 8.2875 11.75 8.5V11.75H8.5C8.2875 11.75 8.10942 11.8219 7.96575 11.9658C7.82192 12.1096 7.75 12.2878 7.75 12.5003C7.75 12.7129 7.82192 12.891 7.96575 13.0345C8.10942 13.1782 8.2875 13.25 8.5 13.25H11.75ZM12.5017 22C11.1877 22 9.95267 21.7507 8.7965 21.252C7.64033 20.7533 6.63467 20.0766 5.7795 19.2218C4.92433 18.3669 4.24725 17.3617 3.74825 16.206C3.24942 15.0503 3 13.8156 3 12.5017C3 11.1877 3.24933 9.95267 3.748 8.7965C4.24667 7.64033 4.92342 6.63467 5.77825 5.7795C6.63308 4.92433 7.63833 4.24725 8.794 3.74825C9.94967 3.24942 11.1844 3 12.4983 3C13.8123 3 15.0473 3.24933 16.2035 3.748C17.3597 4.24667 18.3653 4.92342 19.2205 5.77825C20.0757 6.63308 20.7528 7.63833 21.2518 8.794C21.7506 9.94967 22 11.1844 22 12.4983C22 13.8123 21.7507 15.0473 21.252 16.2035C20.7533 17.3597 20.0766 18.3653 19.2218 19.2205C18.3669 20.0757 17.3617 20.7528 16.206 21.2518C15.0503 21.7506 13.8156 22 12.5017 22ZM12.5 20.5C14.7333 20.5 16.625 19.725 18.175 18.175C19.725 16.625 20.5 14.7333 20.5 12.5C20.5 10.2667 19.725 8.375 18.175 6.825C16.625 5.275 14.7333 4.5 12.5 4.5C10.2667 4.5 8.375 5.275 6.825 6.825C5.275 8.375 4.5 10.2667 4.5 12.5C4.5 14.7333 5.275 16.625 6.825 18.175C8.375 19.725 10.2667 20.5 12.5 20.5Z",
    fill: "#082A6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add_circle.140dc7ef68915162de43e1631cee0451.svg";
export { ForwardRef as ReactComponent };